import React from 'react';
import styled from 'styled-components';
import { Button} from 'advenio-components'

const Actions = styled.div`
    text-align: end;
`

const Desc = styled.div`
    margin-bottom: 1rem;
    color:#637381;
`

const Msg = styled.div`
    margin-bottom: .5rem;
    span{
        font-weight: 600;
    }
`

const DeleteCenterVideos = ({center_name = '', description = '', onClickConfirm, onClickCancel}) => (<div>
    <Msg>
        Esta seguro de eliminar los videos para el centro&nbsp;
        <span>{center_name}</span>?
    </Msg>
    <Desc>
        {description} 
    </Desc>

    <Actions>
        <Button primary small onClick={onClickConfirm}>
            <span>Si</span>
        </Button>
        <Button danger small onClick={onClickCancel}>
            <span>No</span>
        </Button>
    </Actions>
</div>);

export default DeleteCenterVideos


// WEBPACK FOOTER //
// ./src/Containers/VideoGenerator/DeleteCenterVideos.jsx